/* @flow */
import * as React from 'react';

const Facebook = props => (
  <svg width={10} height={20} viewBox="0 0 10 20" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#5B649B"
      fillRule="evenodd"
      d="M7.2,3.2 L9.3,3.2 C9.48,3.2 9.6,3.072 9.6,2.88 L9.6,0.32 C9.6,0.128 9.48,0 9.3,0 L6.9,0 C4.68,0 3,1.792 3,4.16 L3,7.04 L0.3,7.04 C0.12,7.04 0,7.168 0,7.36 L0,9.92 C0,10.112 0.12,10.24 0.3,10.24 L3,10.24 L3,18.88 C3,19.072 3.12,19.2 3.3,19.2 L5.7,19.2 C5.88,19.2 6,19.072 6,18.88 L6,10.24 L8.7,10.24 C8.82,10.24 8.94,10.112 9,9.984 L9.6,7.424 C9.6,7.36 9.6,7.232 9.54,7.168 C9.48,7.104 9.42,7.04 9.3,7.04 L6,7.04 L6,4.48 C6,3.776 6.54,3.2 7.2,3.2 Z"
    />
  </svg>
);

export default Facebook;



// WEBPACK FOOTER //
// ./src/assets/images/icons/facebook.js